import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import {
	tableRemoveAcount,
	tableUpdate,
	tableClientsUpdate
} from './tableActions';
import Notification from '../../handlers/Notification';
import { regexValidateUserName } from './UtilsOperation';

const showC  = () => {
    return (dispatch,getState) => {
       return axios.get(URL + getState().company.id + '/clients').then( (res) => {
            dispatch({
                type: 'FETCH_CLIENT',
                client: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_user_data});
        });
    }
}

const getAllClients  = (page=1,query) => {
    return (dispatch,getState) => {
        const { company, json_lang } = getState();
        return axios.get(`${URL + company.id }/clients?limit=10&page=${page}${query ? `&name=ilike ${query}`:``}`).then( (res) => {
            dispatch({
                type: 'FETCH_ALL_CLIENTS',
                allClients: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_user_data});
        });
    }
}

const clearClient = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'CLEAR_CLIENT',
            client: {},
            dropzoneFiles:[]
        })
    }
}

const clearClientAdvanceConfig = () => {
    return (dispatch) => {
        dispatch({
            type: "INVALID_ADVANCE_CONFIG",
            invalidConfig: {}
        });
    }
}

const fetchClientsByIds = (fieldGroups = {}) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        const params = Object.entries(fieldGroups)
            .filter(([, values]) => values.length > 0)
            .map(([field, values]) => `${field}=:in:${values.join(',')}`)
            .join('&');
        return axios.get(`${URL + company.id}/clients?${params}`)
        .then((res) => {
            dispatch({
                type: 'FETCH_PAGINATED_CLIENTS',
                paginated_clients: res.data
            })
            return res.data;
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_user_list });
        });
    }
}

const fetchClients  = (page = 1, search_query = '', filter_query = '', loader = true) => {
    return (dispatch,getState) => {
		const { company, json_lang } = getState();
        if(loader){
            dispatch({type: "WAIT_FOR_RESPONSE"});
        }
		let url_host = `${URL + company.id}/clients?page=${page}`;
		url_host += (search_query !== '') ? ('&search=' + search_query) : '';
		url_host += (filter_query !== '') ? ('&' + filter_query) : '';

        return axios.get(url_host).then( (res) => {
            dispatch({
                type: 'FETCH_PAGINATED_CLIENTS',
                paginated_clients: res.data
            })
        }).catch((err) => {
            if(loader){
                dispatch({type: "REMOVE_LOADING"});
            }
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_user_list });
        });
    }
}

const fetchArchivedClients  = (page = 1, search_query = '', filter_query = '') => {
    return (dispatch,getState) => {
		const { company, json_lang } = getState();

		let url_host = `${URL + company.id}/clients?mode=deleted&page=${page}`;
		url_host += (search_query !== '') ? ('&search=' + search_query) : '';
		url_host += (filter_query !== '') ? ('&' + filter_query) : '';

        return axios.get(url_host).then( (res) => {
            dispatch({
                type: 'FETCH_PAGINATED_CLIENTS',
                paginated_clients: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.user_delete_failed });
        });
    }
}

const autoComplete = (query = "") => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/clients' + (query ? "?search="+query : ''))
        .then( (res) => {
            dispatch({
                type: 'AUTOCOMPLETE_CLIENT',
                clients: res.data.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message });
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_user_data });
        });
    }
}

const searchQueryClients = (query = "") => {
   return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/clients' + (query ? "?search=" + query : ''))
        .then( (res) => {
            dispatch({
                type: 'AUTOCOMPLETE_CLIENT',
                clients: res.data.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_user_data });
        });
    }
}

const find = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/clients/' + id + '?with=addresses,account').then( (res) => {
           dispatch({
                type: 'FETCH_CLIENT',
                client: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_user_data });
        });
    }
}

const toggleData = (value) => {
    return (dispatch,getState) => {
        var data = {
            ...getState().client,
        }
        data[value.name] = value.data;

		dispatch({
		    type: 'FETCH_CLIENT',
		    client: data
		})
    }
}

const restoreClient = (id) => {
    return (dispatch,getState) => {
        const { client } = getState();
        return axios.post(URL + getState().company.id + '/accounts/'+ id + '/restore').then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.restored_user});
            dispatch({
                type: 'UPDATE_CLIENT',
                paginated_clients: tableRemoveAcount(res, "paginated_clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                },
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const register = (data) => {
    return (dispatch,getState) => {
        if( regexValidateUserName(data.name)){
            Notification.show({type: "error", title:``, msg: `Error maldito`});
            return
        }

        var client={
            name:data.name,
            email:data.email,
            phone:data.phone
        }
        return axios.post(URL + getState().company.id + '/clients', client).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful });
            dispatch({
                type: 'REGISTER_CLIENT_SUCCESS',
                client: res.data
            })
            //dispatch(REGISTER_CLIENT_SUCCESS(client))
        }).catch((err) => {
            if ( err.data && err.data.message.indexOf("already_exists") === 0 )
                Notification.show({type: "error", title: getState().json_lang.custom_errors.user_registration_failed, msg: getState().json_lang.custom_errors.client_already_exist});
            else if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_registration_failed });
        });
    }
}

const update = (data) => {
    return (dispatch,getState) => {
		const { company, json_lang } = getState();
        /* var client = new FormData();
        client.append('email', data.email)
        client.append('name', data.name)
		client.append('phone', data.phone) */
		const client = {
			'name': data.name,
			'phone': data.phone
		}

        /* if(getState().dropzoneFiles.length){
           client.append('avatar', getState().dropzoneFiles[0] )
        }else if(data.avatar_url && data.avatar_url.length ){
           client.append('avatar_url', data.avatar_url)
        }else{
            client.append('avatar_url', URLsmall+'assets/img/avatars/default.png')
        } */

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(URL +  company.id + '/clients/' + data.id, client).then((res) => {
			if (data.email !== res.data.email) {

				axios.post(`${URL+ company.id}/accounts/${res.data.account_id}/update-email`, { email: data.email })
					.then((resEmail) => {

						res.data.email = resEmail.data.email;
						dispatch({
							type: 'UPDATE_CLIENT',
							paginated_clients: tableClientsUpdate(res, "paginated_clients"),
                            client: {
                                account: {
                                    ...getState().client.account,
                                    status: res.data.status
                                },
                                ...res.data
                            }
						})
                        dispatch({
                            type: ""
                        })
						Notification.show({
							type: "success",
							title: json_lang.common.success,
							msg: json_lang.custom_success.update_successful
						});
					})
					.catch(err => {
						if(err.message && err.message !== 'generic')
							Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
						else
							Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.user_update_failed });
					})
			}
			else {
				dispatch({
					type: 'UPDATE_CLIENT',
					paginated_clients: tableClientsUpdate(res, "paginated_clients"),
                    client: {
                        account: {
                            ...getState().client.account,
                            status: res.data.status
                        },
                        ...res.data
                    }
				})
				Notification.show({
					type: "success",
					title: getState().json_lang.common.success,
					msg: getState().json_lang.custom_success.update_successful
				});
			}
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_update_failed });
        });
    }
}

const updateWithoutClear = (data) => {
    return (dispatch,getState) => {
        var client = new FormData();
        client.append('email', data.email)
        client.append('name', data.name)
        client.append('phone', data.phone)

        if(getState().dropzoneFiles.length){
           client.append('avatar', getState().dropzoneFiles[0] )
        }else if(data.avatar_url && data.avatar_url.length ){
           client.append('avatar_url', data.avatar_url)
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + getState().company.id + '/clients/' + data.id , client ).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg: getState().json_lang.custom_success.update_successful });
            dispatch({
                type: 'UPDATE_CLIENT',
                clients: tableUpdate(res, "clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                }
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed });
        });
    }
}

const destroy = (id) => {
    return (dispatch,getState) => {
        const { client } = getState();
        return axios.delete(URL + getState().company.id + '/accounts/'+ id)
        .then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.delete_successful});
            dispatch({
                type: 'UPDATE_CLIENT',
                paginated_clients: tableRemoveAcount(res, "paginated_clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                },
                preloader: false
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed });
        });
    }
}

const block = (id) => {
    return (dispatch,getState) => {
        return axios.post(`${URL + getState().company.id}/accounts/${id}/block`).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            let client = getState().paginated_clients.data.find((client, key) => {
                return parseInt(client.account_id,10) === parseInt(id,10)
            })
            if(client){
                client.account.status = res.data.status;
            }

            dispatch({
                type: 'UPDATE_CLIENT',
                paginated_clients: tableClientsUpdate(res, "paginated_clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                }
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed });
        });
    }
}
const disable = (id) => {
    return (dispatch,getState) => {
        return axios.post(`${URL + getState().company.id}/accounts/${id}/disable`).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
              let client = getState().paginated_clients.data.find((client, key) => {
                return parseInt(client.account_id,10) === parseInt(id,10)
            })
            if(client){
                client.account.status = res.data.status
            }

            dispatch({
                type: 'UPDATE_CLIENT',
                paginated_clients: tableClientsUpdate(res, "paginated_clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                }
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed });
        });
    }
}
const statusAccount = (id,statusAccount) => {
    return (dispatch,getState) => {
        return axios.post(`${URL}${getState().company.id}/accounts/${id}/${statusAccount}`).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.restored_user});

            let client = getState().paginated_clients.data.find( (client,key) => {
                return parseInt(client.account_id,10) === parseInt(id,10)
            })
            if(client){
                client.account.status = res.data.status
            }

            dispatch({
                type: 'UPDATE_CLIENT',
                paginated_clients: tableClientsUpdate(res, "paginated_clients"),
                client: {
                    account: {
                        ...res.data,
                        status: res.data.status
                    },
                    ...res.data.client
                }
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}
const fetchAvailableSellers = (clientId) => {
    return (dispatch,getState) => {
        return axios.get(`${URL}${getState().company.id}/clients/${clientId}/admins`).then( (res) => {
            let adminsToAsing = [...getState().admins];
            let assinedAdmins = res.data.map((admin) =>  admin.id)
            let avaliableToAsing;

            if(res.data && res.data.length>0){
                avaliableToAsing = adminsToAsing.filter((admin) => !assinedAdmins.includes(admin.id));
            }

            dispatch({
                type: 'ATTACHABLE_ADMINS',
                adminsToAsing: res.data,
                admins: res.data && res.data.length>0 ? avaliableToAsing : adminsToAsing,
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : getState().json_lang.custom_errors.retrieving_user_list
            });
        });
    }
}

const attachAssigmentAdmin = (adminId) => {
    return (dispatch,getState) => {
        let adminsToAsing = getState().adminsToAsing && getState().adminsToAsing.length > 0 ? [...getState().adminsToAsing] : [];
        let admins = [...getState().admins];
        let newAssing = admins.find((admin) => admin.id === adminId);
        adminsToAsing.push(newAssing)
        let adminsUpdate = getState().admins.filter((admin) =>  admin.id !== adminId )
        dispatch({
            type: 'ATTACHABLE_ADMINS',
            adminsToAsing: adminsToAsing,
            admins: adminsUpdate,
        })
    }
}

const dettachAssigmentAdmin = (adminId) => {
    return (dispatch,getState) => {
        let adminsToAsing = [...getState().adminsToAsing];
        let admins = [...getState().admins];

        let avaliableAssing = adminsToAsing.find((admin) => admin.id === adminId);
        admins.push(avaliableAssing)

        let adminsUpdate = adminsToAsing.filter((admin) =>  admin.id !== adminId )
        dispatch({
            type: 'ATTACHABLE_ADMINS',
            adminsToAsing: adminsUpdate,
            admins: admins,
        })
    }
}

const assigmentSellers = (adminId) => {
    return (dispatch,getState) => {
        let assigmentSellers= [...getState().adminsToAsing].map((seller) =>  seller.id)
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.put(`${URL}${getState().company.id}/clients/${adminId}/admins`,assigmentSellers).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg: getState().json_lang.custom_success.saved_successful });
            dispatch({type: 'REMOVE_LOADING'})
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const setMainSeller = (clientId,adminId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL}${getState().company.id}/clients/${clientId}/admins/${adminId}/set-main`).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg: getState().json_lang.custom_success.saved_successful });
            dispatch({type: 'REMOVE_LOADING'})
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: ""});
        });
    }
}

const getClientSettings = (clientId) => {
    return(dispatch, getState) => {
        const { company } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.get(`${URL}${company.id}/clients/${clientId}/settings`).then((res) => {
            dispatch({
                type: "FETCH_CLIENT_SETTINGS",
                clientSettings:  res.data
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: "Error al obtener los datos de pago del cliente"});
        });
    }
}

const setClientPayoutAccount = (clientId, data, fromInvoice) => {
    return(dispatch, getState) => {
        const { company, json_lang, invoice } = getState();

        const paymentData = {
            payout_accounts: [ ...data]
        }

        return axios.patch(`${URL}${company.id}/clients/${clientId}/settings`, paymentData).then((res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            if(fromInvoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...invoice,
                        payout_accounts:paymentData.payout_accounts
                    }
                });
            } else {
                dispatch({
                    type: 'FETCH_CLIENT_SETTINGS',
                    clientSettings: res.data
                })
            }
		}).catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al guardar el método de pago" });
		});
    }
}

const payClientPm = (accountId, data) => {
    return(dispatch, getState) => {
        const { company, json_lang } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.post(`${URL}${company.id}/accounts/${accountId}/account-balances/withdraw`, data).then(() => {
            dispatch({type: 'REMOVE_LOADING'});
            Notification.show({ type: "success", title:json_lang.common.success, msg:"Pago enviado con éxito" });
		}).catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al realizar el pago" });
		});
    }
}

const updateClientAddress = (address) => {
    return(dispatch, getState) => {
        const { company, json_lang, client } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.patch(`${URL}${company.id}/client-addresses/${address.id}`, address).then((res) => {
            dispatch({
                type: 'FETCH_CLIENT',
                client: {
                    ...client,
                    addresses: client.addresses.map(item => {
                        return item.id === address.id ? res.data : item
                    })
                }
            })
            Notification.show({ type: "success", title:json_lang.common.success, msg:"Dirección actualizada con éxito" });
		}).catch((err) => {
            dispatch({type: 'REMOVE_LOADING'});
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al actualizar la dirección" });
		});
    }
}

const updateClientAdvanceSettings = (body, id) => {
    return (dispatch,getState) => {
        let { company, json_lang } = getState();

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL + company.id}/clients/${id}/settings`, { ...body }).then( (res) => {
            Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: "INVALID_ADVANCE_CONFIG",
                invalidConfig: {}
            });
        })
        .catch((err) => {
            dispatch({type: "REMOVE_LOADING"})  
            if(err.data && err.data.error_code){
                const error = err.data;
                switch(error.error_code){
                    case 'ER422':
                        if(error.errors){
                            const errors = Object.keys(error.errors).reduce((acc, key) => {
                                const splitedKey = key.split(".");
                                acc[splitedKey[1]] = json_lang.custom_errors[splitedKey[1] + "_format"];
                                return acc;
                            }, {});
                            dispatch({
                                type: "INVALID_ADVANCE_CONFIG",
                                invalidConfig: {
                                    ...errors
                                },
                            });
                        } else {
                            if(error.description){
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                            } else {
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Ocurrió un error inesperado al guardar los datos" });
                            }
                        }
                        break;
                    case 'ER409':
                        if(error.errors){
                            const errors = Object.keys(error.errors).reduce((acc, key) => {
                                const splitedKey = key.split(".");
                                acc[splitedKey[1]] = json_lang.custom_errors[splitedKey[1] + "_conflict"];
                                return acc;
                            }, {});
                            dispatch({
                                type: "INVALID_ADVANCE_CONFIG",
                                invalidConfig: {
                                    ...errors
                                },
                            });
                        } else {
                            if(error.description){
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                            } else {
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Ocurrió un error inesperado al guardar los datos" });
                            }
                        }
                        break;
                    default:
                        if(error.description){
                            Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                        } else {
                            Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Error al guardar los datos" });
                        }
                        break;
                }
            } else {
                Notification.show({type: "error", title:`Error`, msg: "Error al guardar los datos" });
            }
        });
    }
}


export {
    getAllClients,
	clearClient,
    clearClientAdvanceConfig,
	setMainSeller,
	assigmentSellers,
	dettachAssigmentAdmin,
	attachAssigmentAdmin,
	fetchAvailableSellers,
    updateWithoutClear,
    fetchClients,
    fetchClientsByIds,
    fetchArchivedClients,
    showC,
    register,
    restoreClient,
    searchQueryClients,
    destroy ,
    toggleData ,
    update,
    autoComplete,
    find,
    block,
    disable,
    statusAccount,
    getClientSettings,
    setClientPayoutAccount,
    payClientPm,
    updateClientAddress,
    updateClientAdvanceSettings
};



// WEBPACK FOOTER //
// ./src/store/actions/clientActions.js